<template>
  <div></div>
</template>

<script>
export default {
  name: 'SatelliteLayer',
  props: {
    map: {
      required: true,
    },
    layerUrl: {
      required: true,
    },
    layerId: {
      required: true,
    }
  },
  methods: {
    initSatelliteLayer() {
      this.map.addSource(this.layerId, {
        type: 'raster',
        tiles: [
          this.layerUrl
        ],
        tileSize: 256,
        scheme: 'tms'
      })

      let layers = this.map.getStyle().layers
      let layerIdList = []
      for (let i = 0; i < layers.length; i++) {
        layerIdList.push(layers[i].id)
      }

      let targetBeforeLayerId = ''
      // 若当前展示的图层列表没有其他卫星影像图层，则卫星影像图层添加到roadInfo下面第一个图层的前面
      for (let i = 0; i < layers.length; i++) {
        if (layers[i].id === 'roadInfo') {
          targetBeforeLayerId = layers[i + 1].id
        }
        if (layers[i].id.startsWith('satelliteLayer')) {
          targetBeforeLayerId = layers[i + 1].id
        }
      }
      this.map.addLayer({
        id: 'satelliteLayer' + this.layerId,
        type: 'raster',
        source: this.layerId
      }, targetBeforeLayerId)
    },
    removeSatelliteLayer() {
      if (this.map.getLayer('satelliteLayer' + this.layerId)) {
        this.map.removeLayer('satelliteLayer' + this.layerId)
      }
      if (this.map.getSource(this.layerId)) {
        this.map.removeSource(this.layerId)
      }
    }
  },
  mounted() {
    this.initSatelliteLayer()
  },
  beforeDestroy() {
    this.removeSatelliteLayer()
  }
}
</script>

<style scoped>

</style>